module.exports = __webpack_public_path__ + "static/img/577_phase_function_Paper_Points.2d6777b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/577_phase_function_Paper_Points.png
// module id = xliH
// module chunks = 0